var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSvg && _vm.isCorsSafe)?_c('svg',{style:(("width:" + _vm.iconSize + "; height:" + _vm.iconSize + "; fill:" + _vm.iconColor + "; stroke:" + _vm.stroke + "; " + (_vm.stroke ? 'stroke-width: 25px;' : ''))),attrs:{"data-src":_vm.source.Logo + '#Content'}}):_c('img',{style:({
    maxWidth: _vm.iconSize,
    height: 'auto',
    filter: _vm.getFilter,
  }),attrs:{"src":_vm.source.Logo,"alt":_vm.source.Name}})}
var staticRenderFns = []

export { render, staticRenderFns }